import { gql } from '@apollo/client';

export const COMBOS = gql`
  query comboList($input: ComboListInput!) {
    comboList(input: $input) {
      id
      title
      cost
      quantity
      use_global_discounts

      tariff {
        id
        title
        duration
        cost
        time_from
        time_to
        has_fixed_finish_time
        per_minute
        pausable
        booked
        disable_sale_receipt_printing
      }

      items {
        entity_type
        amount
        price

        entity {
          ... on Service {
            id
            title
            cost
            wholesale_cost
            tax_percent
            created_at
            vat
            tax_system
          }

          ... on Good {
            id
            title
            cost
            amount
            use_fair_sign
            vat
            tax_system
            is_excise
            available_to_buy
          }
        }
      }
    }
  }
`;
